var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "widM txtC marTML" }, [
        _c(
          "a",
          {
            staticClass: "disIb fntH5 bold NCAcmi_arrow",
            staticStyle: { background: "#20893d", color: "#fff" },
            on: { click: _vm.openActivityPopup }
          },
          [
            _vm._v("\n      액티비티 정보 안내  \n      "),
            _c("img", {
              staticStyle: {
                "max-width": "10px",
                width: "2%",
                "vertical-align": "baseline"
              },
              attrs: {
                src: require("@/views/survey2/images/NCAcmi_arrow.png"),
                alt: ""
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "fntE txtL marTSM padBS",
            staticStyle: { color: "#d91734" }
          },
          [
            _vm._v(
              "* 액티비티별 잔여 인원은 제출 시간에 따라 차이가 있을 수 있습니다."
            )
          ]
        ),
        _vm._v(" "),
        _vm.isVip
          ? _c("p", { staticClass: "fntE txtL padBS" }, [
              _c("b", [
                _vm._v(
                  "FC VIP 액티비티 골프/스파 조당 6개, EDC 골프/스파 조당 4개, DIA 골프/스파 조당 2개"
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "데일리 액티비티는 골프/스파/액티비티 중 1회만 참여 가능합니다. "
              ),
              _c("br"),
              _vm._v(
                "양도를 위해 복수 선택이 가능하나, 본인이 중복 선택으로 참여 시 액티비티 참여가 불가능 합니다."
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("hr", {
        staticStyle: {
          "border-top": "1px solid #ddd",
          background: "#f4f4f4",
          padding: "5px 0"
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.activities, function(activity, sq_code, i) {
        return [
          _c("SurveyActivityParticipant", {
            key: "activity_" + sq_code,
            attrs: { activity: activity, "is-first": i === 0 }
          }),
          _vm._v(" "),
          i < _vm.activityCount - 1
            ? _c("hr", {
                key: "hr_" + activity.sq_code,
                staticStyle: {
                  "border-top": "1px solid #ddd",
                  background: "#f4f4f4",
                  padding: "5px 0"
                }
              })
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "marTML", staticStyle: { background: "#f4f4f4" } },
      [
        _c(
          "div",
          {
            staticClass: "widM fntH4 bold padTS padBS",
            staticStyle: { color: "#2c2c2c" }
          },
          [_vm._v("액티비티 예약")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "osResTbScrollWrap marTML NCAcmi_table widM" },
      [
        _c("div", { staticClass: "osResTbScroll osResTbBlock" }, [
          _c("table", { staticClass: "osResTb05 txtC" }, [
            _c("caption", [
              _vm._v(
                "\n          액티비티 예약 날짜별 시간 일정 안내\n        "
              )
            ]),
            _vm._v(" "),
            _c("colgroup", [
              _c("col", { staticStyle: { width: "23%" } }),
              _vm._v(" "),
              _c("col", { staticStyle: { width: "auto" } }),
              _vm._v(" "),
              _c("col", { staticStyle: { width: "20%" } }),
              _vm._v(" "),
              _c("col", { staticStyle: { width: "auto" } }),
              _vm._v(" "),
              _c("col", { staticStyle: { width: "23%" } })
            ]),
            _vm._v(" "),
            _c("thead", [
              _c("tr", [
                _c("th", { attrs: { scope: "col" } }, [_vm._v("Day 1")]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } }, [_vm._v("Day 2")]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } }, [_vm._v("Day 3")]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } }, [_vm._v("Day 4")]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col" } }, [_vm._v("Day 5")])
              ])
            ]),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("td", { attrs: { rowspan: "3" } }, [
                  _vm._v("체크인 &"),
                  _c("br"),
                  _vm._v(" 오리엔테이션")
                ]),
                _vm._v(" "),
                _c("td", { attrs: { colspan: "3" } }, [
                  _vm._v("선택 프로그램 진행")
                ]),
                _vm._v(" "),
                _c("td", { attrs: { rowspan: "2" } }, [
                  _vm._v("호텔 액티비티 & "),
                  _c("br"),
                  _vm._v("쇼핑몰"),
                  _c("br"),
                  _vm._v("비즈니스 미팅"),
                  _c("br"),
                  _vm._v("체크아웃")
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { attrs: { colspan: "3" } }, [
                  _vm._v("\n              1. 짚라인 액티비티"),
                  _c("br"),
                  _vm._v("\n              2. 래프팅 액티비티"),
                  _c("br"),
                  _vm._v("\n              3. 몬쨈 글램핑"),
                  _c("br"),
                  _vm._v("\n              4. 매땡 코끼리 캠프"),
                  _c("br"),
                  _vm._v("\n              5. 도이 인타논"),
                  _c("br"),
                  _vm._v("\n              6. 도이수텝 & 올드시티"),
                  _c("br"),
                  _vm._v("\n              7. 반캉왓 민예마을 & 왓우몽 사원"),
                  _c("br"),
                  _vm._v(
                    "\n              8. 마사지 & 쇼핑몰 (*마사지: 만 15세 이상 참여 가능)"
                  ),
                  _c("br"),
                  _vm._v("\n              9. 호텔 휴식\n            ")
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("웰컴 디너")]),
                _vm._v(" "),
                _c("td", [_vm._v("자유 석식")]),
                _vm._v(" "),
                _c("td", [_vm._v("갈라 디너")]),
                _vm._v(" "),
                _c("td", [_vm._v("호텔 석식")])
              ])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fb7a29f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fb7a29f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey2/components/SurveyActivityList.vue
// module id = null
// module chunks = 